import React from 'react'
import { Dyaded, FooterContainer, FooterLogo, FooterMax, FooterSocial } from './footerStyle'
import ImgLogo from './../../assets/img/footer.png'
import { Facebook, Instagram, Tiktok } from '../helpers/Helper'

export default function Footer() {
  return (
    <FooterContainer>
      <FooterMax>
        <FooterSocial>
          <Facebook/>
          <Instagram/>
          <Tiktok/>
        </FooterSocial>
        <FooterLogo>
          <img src={ImgLogo} alt="logo"/>
          <p>
          &copy;Cluckin'Bell React App | Designed and developed by <Dyaded href='https://dyaded.netlify.app/' target='_blank'>Dyaded</Dyaded>
          </p>
        </FooterLogo>
        
      </FooterMax>
    </FooterContainer>
  )
}
